import { config } from '../main.js';
import { ctx } from '../canvas.js';
import * as player from '../player.js';

export {
    draw,
}

function draw() {
    ctx.fillStyle = 'white';
    ctx.font = '400 14px Dosis';
    ctx.fillText(
        `${Math.abs(player.position.y.toFixed(1))} m ${player.position.y <= 0 ? 'N' : 'S'}`,
        20,
        config.height - 20
    );
    ctx.fillText(
        `${Math.abs(player.position.x.toFixed(1))} m ${player.position.x >= 0 ? 'E' : 'O'}`,
        20,
        config.height - 35
    );
}